/**
 * AiIntent.js — Detects the user's intent from free text.
 * Used when the user types in the input instead of clicking a chip.
 */

const PATTERNS = {
  generate: /crea|genera|nuevo proceso|quiero un|hacer un|diseña/i,
  explain:  /explica|qué hace|cómo funciona|describí|qué es|describe/i,
  validate: /valida|verifica|hay errores|revisar|problemas|errores/i,
  modify:   /agrega|quita|cambia|renombra|modifica|elimina|añade/i,
  suggest:  /sugerir|mejorar|optimizar|qué falta|podría|mejoras/i,
  document: /documenta|describe para|resumen|ejecutivo|documentación/i,
};

/**
 * @param {string} text
 * @returns {'generate'|'explain'|'validate'|'modify'|'suggest'|'document'|'chat'}
 */
export function detectIntent(text) {
  for (const [intent, re] of Object.entries(PATTERNS)) {
    if (re.test(text)) return intent;
  }
  return 'chat';
}
